export default __webpack_public_path__ + "static/media/icon-file-pdf.454d27c4.svg";